import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { PermissionRecord, PermissionState } from './model';

const initialState: PermissionState = {
  records: [],
  groupData: [],
};

export const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setPermissionData(state, action: PayloadAction<PermissionRecord[]>) {
      state.records = action.payload;
    },
    setPermissionGroup(state, action: PayloadAction<string[]>) {
      state.groupData = action.payload;
    },
  },
});

export const { setPermissionData, setPermissionGroup } =
  permissionSlice.actions;

export default permissionSlice;
